const namespace = "snapStrip";

export const HEADER = `${namespace}.header`;
export const TITLE = `${namespace}.title`;
export const TOOLTIP_TITLE = `${namespace}.tooltipTitle`;
export const TOOLTIP_SUBTITLE = `${namespace}.tooltipSubtitle`;
export const TOOLTIP_DESCRIPTION = `${namespace}.tooltipDescription`;
